import styled from 'styled-components'

const HeaderStyled = styled.header`
  padding-top: var(--header-offset);
  padding-bottom: var(--header-offset);
  max-height: var(--screen-header-max-height);
`

export default HeaderStyled
